import { Controller } from "@hotwired/stimulus"

// The game tiles. Five games is a fixed, small set, so it stays visible
// instead of collapsing into a select.
//
// The tiles are the visible control but not the value: they write to a hidden
// `season[game]` field and fire a `change` on it, because car-classes-form
// already listens there and owns the "switching game drops these classes"
// confirm. That controller may put the old value back if the organizer
// cancels, so the pressed state is re-read from the input rather than assumed.
export default class extends Controller {
  static targets = ["tile", "input"]

  connect() {
    this._sync()
    this._resync = () => this._sync()
    this.inputTarget.addEventListener("change", this._resync)
    // Backing out of the "switching game drops these classes" confirm puts the
    // old value back without a `change` event, so the tiles are told separately.
    this.element.addEventListener("car-classes-form:gameReverted", this._resync)
    document.addEventListener("car-classes-form:gameReverted", this._resync)
  }

  disconnect() {
    this.inputTarget.removeEventListener("change", this._resync)
    this.element.removeEventListener(
      "car-classes-form:gameReverted",
      this._resync,
    )
    document.removeEventListener("car-classes-form:gameReverted", this._resync)
  }

  pick(event) {
    const value = event.currentTarget.dataset.value
    // Picking the current game again clears it — the field is optional, and
    // without this there is no way back to "no game" once one is chosen.
    this.inputTarget.value = this.inputTarget.value === value ? "" : value
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this._sync()
  }

  _sync() {
    const current = this.inputTarget.value
    this.tileTargets.forEach((tile) => {
      tile.setAttribute("aria-pressed", String(tile.dataset.value === current))
    })
  }
}
